/**
  * @depend google.maps api
  * @param options - Optional parameters.
  * @param options.zoomLvl - The initial zoom lvl of the map.
  * @param options.countryRestrictions - string or arr array of ISO 3166-1 country codes.
  * @param options.markerImageSrc - Overwrite default distributor marker icon.
  * @param options.markerCurrentImageSrc - Overwrite default standard maps marker icon.
  * @param options.searchDistance - Overwrite default search distance for postalcode.
  * @param options.maxResults - The maximal result count.
  * @param htmlElements - html objects.
  * @param strings - Al text strings in javascript (useful for translations).
  */

function SearchDistributor(options, htmlElements, strings){
	this.htmlElements = htmlElements;
	this.distributors = [];
	this.distributorsPrevious = [];

	// default options
	this.options = {
		'zoomLvl' : 15,
		'searchDistance' : 25,
		'maxResultsPerView' : 6
	};

	// merge input options with default options
	for (let attrname in options) { this.options[attrname] = options[attrname]; }

	if (this.options.distributorTypes.indexOf('merchant') >= 0) {
		this.options.maxResultsPerView /= 2;
	}

	// default strings
	this.strings = {
		'noLocationFound' : 'No location found. Did you enter a city/town or postcode?',
		'noDistributorFound' : 'No distributors found.',
		'oneDistributorFound' : '1 distributor found.',
		'xDistributorsFound' : ' distributors found.',
		'loading' : 'Loading..',
		'foundDistributors' : 'Found distributors',
		'gettingLocation' : 'Getting your location.',
		'cannotGetLocation' : 'Sorry, cannot get your location.',
		'moreInformation' : 'More information'
	};

	// merge input strings with default options
	for (let attrname in strings) { this.strings[attrname] = strings[attrname]; }

	// check for dependencies
	if(typeof google === 'undefined' || typeof google.maps === 'undefined'){
		this.statusUpdate('Google maps api not loaded.', 'error');
		return;
	}

	// bind functions
	this.searchDistributors = this.searchDistributors.bind(this);
	this.displayResults = this.displayResults.bind(this);
	this.requestDistributors = this.requestDistributors.bind(this);
	this.parseDistributor = this.parseDistributor.bind(this);
	this.searchDistributorsDevice = this.searchDistributorsDevice.bind(this);
	this.updateInfowindows = this.updateInfowindows.bind(this);
	this.updateDistributorList = this.updateDistributorList.bind(this);
	this.onResize = this.onResize.bind(this);

	this.parseDistributorRequest = new XMLHttpRequest();
	this.parseDistributorRequest.addEventListener('readystatechange', this.parseDistributor);

	if(typeof this.options.ajaxDistributorsUrl != 'string'){
		this.statusUpdate('Cannot make ajax request, url not available or not wel formed.', 'error');
		return;
	}

	// setup defaults
	this.currentResultSet = 1;
	this.maxResultsPerView = this.options.maxResultsPerView;

	// setup maps
	this.geocoder = new google.maps.Geocoder();
	this.autocomplete = new google.maps.places.AutocompleteService();
	this.distanceMatrixService = new google.maps.DistanceMatrixService();

	this.geocoding = false;

	window.addEventListener('resize', this.onResize);
	this.onResize();
}

SearchDistributor.prototype.searchDistributors = function(input){
	if(typeof Hooks === 'function'){
		const hooks = new Hooks();
		hooks.triggerAction('searchDistributorSubmitted', [input]);
	}

	input = input.trim();

	if(typeof input != 'string' || input.length < 1){
		return false;
	}

	// cancel search for device location
	if(this.geolocationWatchId){
		navigator.geolocation.clearWatch(this.geolocationWatchId);
	}

	if(this.geocoding){
		return;
	}

	this.statusUpdate(false);

	this.geocoding = true;

	if(!this.geocoder){
		this.statusUpdate('Geocoder not loaded.', 'error');
		return;
	}

	let componentRestrictions = {
		country: []
	};

	if(this.options.countryRestrictions){
		componentRestrictions.country = this.options.countryRestrictions;
	}

	// place api doesn't like nl postal codes without spaces. To do: should be solved in an other way, now it is hardcoded to NL postal codes.
	if(input.match(/^\d{4}[a-zA-Z]{2}$/)){
		input = input.slice(0, 4) + ' ' + input.slice(4);
	}

	this.autocomplete.getPlacePredictions({
		input: input,
		types: [
			'(regions)'
		],
		componentRestrictions: componentRestrictions
	}, function(predictions, status){
		this.geocoding = false;
		if(status == 'OK'){
			let resultType = false;
			let resultData = false;

			for(let i=0;i<predictions.length;i++){
				for(let j=0;j<predictions[i].types.length;j++){
					if(predictions[i].types[j] == 'postal_code' || predictions[i].types[j] == 'locality' || predictions[i].types[j] == 'administrative_area_level_2'){
						resultType = predictions[i].types[j];
						resultData = predictions[i];
						break;
					}
				}
				if(resultType){
					break;
				}
			}

			if(!resultType){
				this.statusUpdate(this.strings.noLocationFound, 'error');
				return;
			}

			switch(resultType){
				case 'postal_code':
					componentRestrictions.postalCode = resultData.structured_formatting.main_text;
					break;
				case 'locality':
					componentRestrictions.locality = resultData.structured_formatting.main_text;
					break;
				case 'administrative_area_level_2':
					componentRestrictions.administrative_area = resultData.structured_formatting.main_text;
					break;
			}

			this.geocoder.geocode({
					componentRestrictions: componentRestrictions
				}, function(results, status){
				this.geocoding = false;
				if(status == 'OK'){
					var resultType = false;
					var resultData = false;
					var resultValue = false;

					for(let i=0;i<results.length;i++){
						for(let j=0;j<results[i].types.length;j++){
							if(results[i].types[j] == 'postal_code' || results[i].types[j] == 'locality' || results[i].types[j] == 'administrative_area_level_2'){
								resultType = results[i].types[j];
								resultData = results[i];
								break;
							}
						}
						if(resultType){
							break;
						}
					}

					if(!resultType){
						this.statusUpdate(this.strings.noLocationFound, 'error');
						return;
					}

					for(let i=0;i<results.length;i++){
						for(let j=0;j<results[i].address_components.length;j++){
							if(results[i].address_components[j].types.indexOf(resultType) >= 0){
								resultValue = results[i].address_components[j].long_name;
							}
						}
					}

					this.requestDistributors({
						'lat' : resultData.geometry.location.lat(),
						'lng' : resultData.geometry.location.lng()
					}, resultType, resultValue);
				}
				else {
					this.statusUpdate(this.strings.noLocationFound, 'error');
				}
			}.bind(this));
		}
		else {
			this.statusUpdate(this.strings.noLocationFound, 'error');
		}
	}.bind(this));

	this.statusUpdate(this.strings.loading, 'loading');
};

SearchDistributor.prototype.searchDistributorsDevice = function(){
	if(typeof Hooks === 'function'){
		const hooks = new Hooks();
		hooks.triggerAction('searchDistributorSubmitted', ['geo']);
	}

	if('geolocation' in navigator){
		this.geolocationWatchId = navigator.geolocation.watchPosition(
			function(position){
				this.requestDistributors(
					{
						'lat': position.coords.latitude,
						'lng': position.coords.longitude
					},
					'device'
				);
				navigator.geolocation.clearWatch(this.geolocationWatchId);
			}.bind(this),
			function(error){
				this.statusUpdate(this.strings.cannotGetLocation, 'error');
				navigator.geolocation.clearWatch(this.geolocationWatchId);
			}.bind(this)
			);

		if('permissions' in navigator){
			navigator.permissions.query({name:'geolocation'}).then(function(result){
				if(result.state != 'denied'){
					this.statusUpdate(this.strings.gettingLocation, 'loading');
				}
			}.bind(this));
		}
	}
};

SearchDistributor.prototype.requestDistributors = function(location, locationType, locationValue){
	this.currentLocationType = locationType;
	this.currentLocation = location;

	this.parseDistributorRequest.abort();

	var formData = '';

	let searchKeys = [];
	let searchValues = [];

	if(this.options.maxResults){
		formData += '&limit=' + this.options.maxResults;
	}

	if(this.options.searchDistance){
		searchKeys.push('distance');
		searchValues.push(this.options.searchDistance);
	}

	if(locationType == 'postcode' || locationType == 'device'){
		searchKeys.push('location');
		searchValues.push(locationValue);
	}

	if(locationType == 'locality' || locationType == 'administrative_area_level_2'){
		searchKeys.push('city');
		searchValues.push(locationValue);
	}

	if(location.lat && location.lng) {
		searchKeys.push('location');
		searchValues.push(location.lat + ';' + location.lng);
	}

	if(this.options.distributorTypes){
		formData += '&distributor-types=' + (Array.isArray(this.options.distributorTypes) ? this.options.distributorTypes.join(',') : this.options.distributorTypes );
	}

	if(searchKeys.length > 0 && searchKeys.length == searchValues.length) {
		searchValues = searchValues.map(value => {
			if( typeof value == 'string' ) {
				value.replace(',', '');
			}

			return value;
		});

		formData += '&search-keys=' + searchKeys.join(',');
		formData += '&search-values=' + searchValues.join(',');
	}

	if (formData.charAt(0) == '&') {
		formData = formData.substr(1);
	}

	this.parseDistributorRequest.open('POST', this.options.ajaxDistributorsUrl);
	this.parseDistributorRequest.setRequestHeader('Content-type', 'application/x-www-form-urlencoded');
	this.parseDistributorRequest.send(formData);

	this.statusUpdate(this.strings.loading, 'loading');
};

SearchDistributor.prototype.searchSingleDistributor = function(input){
	if(typeof input != 'string' || input.length < 1){
		return false;
	}

	//cancel search for device location
	if(this.geolocationWatchId){
		navigator.geolocation.clearWatch(this.geolocationWatchId);
	}

	if(this.geocoding){
		return;
	}

	this.statusUpdate(false);

	this.geocoding = true;

	if(!this.geocoder){
		this.statusUpdate('Geocoder not loaded.', 'error');
		return;
	}

	this.geocoder.geocode({'address': input}, function(results, status){
		this.geocoding = false;
		if(status == 'OK'){
			var resultType = false;
			var resultData = false;
			var resultValue = false;

			resultType = results[0].types[0];

			if(!resultType){
				this.statusUpdate(this.strings.noLocationFound, 'error');
				return;
			}

			resultData = results[0];
			resultValue = results[0].formatted_address;

			this.options.maxResults = 1;

			this.requestDistributors({
				'lat' : resultData.geometry.location.lat(),
				'lng' : resultData.geometry.location.lng()
			}, resultType, resultValue);

		}
		else {
			this.statusUpdate(this.strings.noLocationFound, 'error');
		}
	}.bind(this));

	this.statusUpdate(this.strings.loading, 'loading');
};

SearchDistributor.prototype.parseDistributor = function(){
	if(this.parseDistributorRequest.readyState != 4) return;
	if(this.parseDistributorRequest.status != 200 && this.parseDistributorRequest.status != 304) {
		console.error('HTTP error ' + this.parseDistributorRequest.status);
		return;
	}

	this.statusUpdate(false);

	if(this.distributors && this.distributors.length > 0){
		this.distributorsPrevious = this.distributors;
	}

	const distributorData = JSON.parse(this.parseDistributorRequest.responseText);

	this.distributors = [];

	distributorData.forEach(distributor => {
		this.distributors.push(new Distributor(distributor));
	});

	if(this.distributors.length < 1){
		this.statusUpdate(this.strings.noDistributorFound);
		return;
	}

	//display results
	this.displayResults();
};

SearchDistributor.prototype.displayResults = function(){
	if(!this.googleMap){
		this.setupResults();
	}

	while(this.listWrapperElement.firstChild){
		this.listWrapperElement.removeChild(this.listWrapperElement.firstChild);
	}

	if(this.distributorsPrevious){
		for(let i=0;i<this.distributorsPrevious.length;i++){
			if(this.distributorsPrevious[i].marker){
				this.distributorsPrevious[i].marker.setMap(null);
			}
		}
	}

	if(this.currentLocationMarker){
		this.currentLocationMarker.setMap(null);
	}

	// paging
	if(this.distributors.length > this.maxResultsPerView){
		this.prevButton = document.createElement('button');
		this.prevButton.setAttribute('class', 'button search-distributor-list-button search-distributor-list-button-prev');
		this.prevButton.appendChild(document.createTextNode('previous'));

		this.prevButton.addEventListener('click', function(){
			this.previousResults();
		}.bind(this));

		this.nextButton = document.createElement('button');
		this.nextButton.setAttribute('class', 'button search-distributor-list-button search-distributor-list-button-next');
		this.nextButton.appendChild(document.createTextNode('next'));

		this.nextButton.addEventListener('click', function(){
			this.nextResults();
		}.bind(this));

		this.listWrapperElement.appendChild(this.prevButton);
		this.listWrapperElement.appendChild(this.nextButton);
	}

	this.listContainerElement = document.createElement('ul');
	this.listContainerElement.setAttribute('class', 'search-distributors-list-container');

	this.listContainerElement.classList.add(this.options.distributorTypes.map(distributorType => {
		return 'search-distributors-list-container-type-' + distributorType.toLowerCase().replace(/\s/g, '-');
	}))

	this.currentResultSet = 1;
	this.updateDistributorList();
	this.updateMarkers();
	this.updateNextPrevButtons();

	this.listWrapperElement.appendChild(this.listContainerElement);

	if(this.distributors.length == 1){
		this.statusUpdate(this.strings.oneDistributorFound);
	}
	else if(this.distributors.length > 1){
		this.statusUpdate(this.distributors.length + this.strings.xDistributorsFound);
	}
	else {
		this.statusUpdate(false);
	}

	document.getElementById('found-distributors').scrollIntoView(true, {
		behavior: 'smooth'
	});
};

SearchDistributor.prototype.setupResults = function(){
	this.resultListWrapperElement = document.createElement('div');
	this.resultListWrapperElement.setAttribute('class', 'search-distributors-result-list-container');

	var listHeaderElement = document.createElement('h3');
	listHeaderElement.setAttribute('class', 'search-distributors-list-header');
	listHeaderElement.appendChild(document.createTextNode(this.strings.foundDistributors));

	this.resultListWrapperElement.appendChild(listHeaderElement);

	this.listWrapperElement = document.createElement('div');
	this.listWrapperElement.setAttribute('class', 'search-distributors-list-wrapper');

	this.resultListWrapperElement.appendChild(this.listWrapperElement);

	this.htmlElements.resultsContainer.appendChild(this.resultListWrapperElement);

	this.mapContainerElement = document.createElement('div');
	this.mapContainerElement.setAttribute('class', 'search-distributors-map-container');

	this.htmlElements.resultsContainer.appendChild(this.mapContainerElement);

	var styles = [
		{
			"featureType": "poi",
			"elementType": "labels",
			"stylers": [
			{ "visibility": "off" }
			]
		},
		{
			"stylers": [
			{ "lightness": 35 },
			{ "saturation": -100 }
			]
		},
		{
			"featureType": "landscape"
		}
	];

	var styledMap = new google.maps.StyledMapType(styles, {name: "Styled Map"});

	var defaultLocation = {'lat' : 52, 'lng' : 6};

	if(this.distributors && this.distributors.length > 0){
		defaultLocation = {'lat' : this.distributors[0].data.location.latitude, 'lng' : this.distributors[0].data.location.longitude};
	}

	var mapOptions = {
		zoom: this.options.zoomLvl,
		disableDefaultUI: false,
		scrollwheel: false,
		mapTypeControl: false,
		streetViewControl: false,
		panControl: true,
		center: defaultLocation,
		mapTypeId: google.maps.MapTypeId.ROADMAP,
	};
	this.googleMap = new google.maps.Map(this.mapContainerElement, mapOptions);

	this.googleMap.mapTypes.set('map_style', styledMap);
	this.googleMap.setMapTypeId('map_style');
};

SearchDistributor.prototype.updateDistributorList = function(){
	if(!this.listContainerElement || this.distributors.length < 1){
		return;
	}

	// empty the container
	while(this.listContainerElement.firstChild){
		this.listContainerElement.removeChild(this.listContainerElement.firstChild);
	}

	let startIndex = (this.currentResultSet - 1) * this.maxResultsPerView;
	let stoptIndex = startIndex + this.maxResultsPerView;
	if(stoptIndex > this.distributors.length){
		stoptIndex = this.distributors.length;
	}

	for(let i = startIndex;i < stoptIndex;i++){
		// if it's already loaded append from reference
		if(this.distributors[i].domContainer && this.distributors[i].domContainer.nodeType == 1){
			this.listContainerElement.appendChild(this.distributors[i].domContainer);
		}
		else {
			let currentLocation = false;
			if(this.currentLocationType == 'postal_code' || this.currentLocationType == 'device'){
				currentLocation = this.currentLocation;
			}

			const listItemElement = this.distributors[i].createListItem(currentLocation);

			if(listItemElement.nodeType == 1){
				this.listContainerElement.appendChild(listItemElement);
				this.distributors[i].domContainer = listItemElement;
			}
		}
	}
};

SearchDistributor.prototype.updateMarkers = function(){
	if(!this.distributors || this.distributors.length < 1){
		return;
	}

	// map
	var markerImage = false;
	var markerCurrentImage = {};

	if(this.options.markerImageSrc && typeof this.options.markerImageSrc == 'string'){
		markerImage = {
			url: this.options.markerImageSrc,
			//size: new google.maps.Size(50, 118),
			scaledSize: new google.maps.Size(50, 59),
			origin: new google.maps.Point(0, 0),
			anchor: new google.maps.Point(25, 59)
		};
	}

	if(this.options.markerCurrentImageSrc && typeof this.options.markerCurrentImageSrc == 'string'){
		markerCurrentImage = {
			url: this.options.markerCurrentImageSrc,
			//size: new google.maps.Size(50, 118),
			scaledSize: new google.maps.Size(50, 59),
			origin: new google.maps.Point(0, 0),
			anchor: new google.maps.Point(25, 59)
		};
	}

	var bounds = new google.maps.LatLngBounds();

	for(let i = 0;i < this.distributors.length;i++){
		if(this.distributors[i].marker){
			this.distributors[i].marker.setMap(null);
		}
	}

	if(this.currentLocationMarker){
		this.currentLocationMarker.setMap(null);
	}

	let startIndex = 0;
	let stoptIndex = this.maxResultsPerView * this.currentResultSet;
	if(stoptIndex > this.distributors.length){
		stoptIndex = this.distributors.length;
	}

	for(let i = startIndex;i < stoptIndex;i++){

		let noMarkerset = false;
		if(!this.distributors[i].marker){
			noMarkerset = true;
			// map
			if(markerImage){
				this.distributors[i].marker = new google.maps.Marker({
					position: new google.maps.LatLng(this.distributors[i].data.location.latitude, this.distributors[i].data.location.longitude),
					icon: markerImage,
					title: this.distributors[i].data.name
				});
			}
			else {
				this.distributors[i].marker = new google.maps.Marker({
					position: new google.maps.LatLng(this.distributors[i].data.location.latitude, this.distributors[i].data.location.longitude),
					title: this.distributors[i].data.name
				});
			}
		}

		if(!this.distributors[i].infowindow){
			let content = '<div class="distributor-infowindow"><strong>' + this.distributors[i].data.name + '</strong><br />' + this.distributors[i].data.address.street + ' ' + this.distributors[i].data.address.houseNumber + '<br />' + this.distributors[i].data.postcode + ' ' + this.distributors[i].data.city;

			if(this.distributors[i].data.phone){
				content += '<br />';
				content += '<a class="distributor-phone" target="_blank" rel="noopener" href="tel:' + this.distributors[i].data.phone.replace(/[^\+\d]/, '') + '">' + this.distributors[i].data.phone + '</a>';
			}
			if(this.distributors[i].data.website){
				let linkRegularExpression = /^https?:\/\//;

				content += '<br />';
				let link = this.distributors[i].data.website;
				if(!link.match(linkRegularExpression)){
					link = 'http://' + link;
				}

				// dummy element
				let linkElement = document.createElement('a');
				linkElement.setAttribute('href', link);

				content += '<a class="distributor-website" target="_blank" rel="noopener" href="' + link + '">' + linkElement.hostname + '</a>';
			}

			content += '</div>';

			this.distributors[i].infowindow = new google.maps.InfoWindow({
				content: content
			});
		}

		if(noMarkerset){
			this.distributors[i].marker.addListener('click', function() {
				this.this.updateInfowindows(this.distributor);
			}.bind({
				'this' : this,
				'distributor' : this.distributors[i]
			}));
		}

		this.distributors[i].marker.setMap(this.googleMap);

		bounds.extend(new google.maps.LatLng(this.distributors[i].data.location.latitude, this.distributors[i].data.location.longitude));
	}

	if(this.currentLocationType == 'postal_code' || this.currentLocationType == 'device'){
		if(markerCurrentImage){
			this.currentLocationMarker = new google.maps.Marker({
				position: this.currentLocation,
				icon: markerCurrentImage,
				map: this.googleMap
			});
		}
		else {
			this.currentLocationMarker = new google.maps.Marker({
				position: this.currentLocation,
				map: this.googleMap
			});
		}
	}
	bounds.extend(this.currentLocation);

	if(this.distributors.length == 1 && !this.currentLocation){
		this.googleMap.setCenter(new google.maps.LatLng(this.distributors[0].data.location.latitude, this.distributors[0].data.location.longitude));
		this.googleMap.setZoom(13);
	}
	else {
		this.googleMap.fitBounds(bounds);
	}
};

SearchDistributor.prototype.previousResults = function(){
	if(this.currentResultSet == 1){
		return;
	}

	this.currentResultSet --;
	this.updateDistributorList();
	this.updateMarkers();
	this.updateNextPrevButtons();
};

SearchDistributor.prototype.nextResults = function(){
	if(this.distributors.length <= this.maxResultsPerView * this.currentResultSet){
		return;
	}

	this.currentResultSet ++;
	this.updateDistributorList();
	this.updateMarkers();
	this.updateNextPrevButtons();
};

SearchDistributor.prototype.updateNextPrevButtons = function(){
	if(!this.distributors || this.distributors.length < 1){
		return;
	}

	if(this.nextButton){
		if(this.nextButton && this.distributors.length <= this.maxResultsPerView * this.currentResultSet){
			this.nextButton.classList.add('is-hidden');
		}
		else {
			this.nextButton.classList.remove('is-hidden');
		}
	}

	if(this.prevButton){
		if(this.currentResultSet == 1){
			this.prevButton.classList.add('is-hidden');
		}
		else {
			this.prevButton.classList.remove('is-hidden');
		}
	}
};

/**
 * Update the infowindows for markers when there is a change.
 *
 * @param object. activeDistributor. Distributor object for the active window.
 * @author Niels Riekert
 */

SearchDistributor.prototype.updateInfowindows = function(activeDistributor){
	for(var i=0;i<this.distributors.length;i++){
		if(activeDistributor == this.distributors[i]){
			this.distributors[i].infowindow.open(this.googleMap, this.distributors[i].marker);
		}
		else if(this.distributors[i].infowindow) {
			this.distributors[i].infowindow.close();
		}
	}
};

SearchDistributor.prototype.statusUpdate = function(message, type){
	if(message === false){
		//if the statusContainer doesn't exist then stop
		if(!this.htmlElements.statusContainer){
			return;
		}

		this.htmlElements.statusContainer.classList.remove('is-active');
		while(this.htmlElements.statusContainer.firstChild){
			this.htmlElements.statusContainer.removeChild(this.htmlElements.statusContainer.firstChild);
		}
		if(this.htmlElements.resultsContainer){
			this.htmlElements.resultsContainer.classList.remove('is-loading');
		}

		return;
	}

	if(!type){
		type = 'notice';
	}

	//put the error in te console also
	switch(type){
		case 'notice':
		case 'loading':
		console.info(message);
		break;
		case 'warning':
		console.warn(message);
		break;
		case 'error':
		console.error(message);
		break;
	}

	if(type == 'loading' && this.htmlElements.resultsContainer){
		this.htmlElements.resultsContainer.classList.add('is-loading');
	}
	else if(this.htmlElements.resultsContainer){
		this.htmlElements.resultsContainer.classList.remove('is-loading');
	}

	//if the statusContainer doesn't exist then stop
	if(!this.htmlElements.statusContainer){
		return;
	}

	//remove current message
	while(this.htmlElements.statusContainer.firstChild){
		this.htmlElements.statusContainer.removeChild(this.htmlElements.statusContainer.firstChild);
	}

	var errorElement = document.createElement('p');
	errorElement.appendChild(document.createTextNode(message));
	errorElement.setAttribute('class', 'message search-distributors-message');

	switch(type){
		case 'warning':
		errorElement.classList.add('message-warning');
		break;
		case 'error':
		errorElement.classList.add('message-error');
		break;
	}

	this.htmlElements.statusContainer.appendChild(errorElement);
	this.htmlElements.statusContainer.classList.add('is-active');

	if(type == 'loading'){
		this.htmlElements.statusContainer.classList.add('is-loading');
	}
	else {
		this.htmlElements.statusContainer.classList.remove('is-loading');
	}
};

SearchDistributor.prototype.onResize = function(){
	if(window.innerWidth <= 500 && this.maxResultsPerView != 3){
		this.maxResultsPerView = 3;
		this.currentResultSet = 1;
		this.updateDistributorList();
		this.updateMarkers();
		this.updateNextPrevButtons();
	}
	else if(window.innerWidth > 500 && this.maxResultsPerView !== this.options.maxResultsPerView){
		this.maxResultsPerView = this.options.maxResultsPerView;
		this.currentResultSet = 1;
		this.updateDistributorList();
		this.updateMarkers();
		this.updateNextPrevButtons();
	}
}

export default SearchDistributor;